import type { TripperDisplayMode } from "./types";

export type WidgetConfig = {
  widgetId: string;
  itineraryId: string;
  status: "active" | "paused";
  displayMode: TripperDisplayMode;
  label: string | null;
  accentColor: string | null;
};

export async function fetchWidgetConfig(
  widgetId: string,
): Promise<WidgetConfig> {
  const serverUrl = import.meta.env.VITE_API_SERVER_URL;
  const res = await fetch(`${serverUrl}/api/widget-config/${widgetId}`);

  if (res.status === 403) {
    const body = await res.json().catch(() => null);
    if (body?.error === "widget_paused") {
      throw new Error("widget_paused");
    }
  }

  if (!res.ok) {
    throw new Error(`Failed to load widget config (${res.status})`);
  }

  return res.json();
}
